import { surveysUiStore } from "../stores";

export const useSurveysUiStore = () => surveysUiStore;
